export enum EImportCustomFieldError {
  CFT_IMPORT_SAME_SITE = 'CFT_IMPORT_SAME_SITE',
  CFT_IMPORT_DUPLICATE_SOURCE = 'CFT_IMPORT_DUPLICATE_SOURCE',
  CFT_IMPORT_UNKNOWN_FIELD = 'CFT_IMPORT_UNKNOWN_FIELD',
  CFT_IMPORT_UNKNOWN_GROUP = 'CFT_IMPORT_UNKNOWN_GROUP',
  CFT_IMPORT_FIELD_NOT_IN_GROUP = 'CFT_IMPORT_FIELD_NOT_IN_GROUP',
  CFT_IMPORT_DUPLICATE_FIELD = 'CFT_IMPORT_DUPLICATE_FIELD',
  CFT_IMPORT_GROUP_INTO_GROUP = 'CFT_IMPORT_GROUP_INTO_GROUP',
  CFT_IMPORT_NAME_CONFLICT = 'CFT_IMPORT_NAME_CONFLICT',
  CFT_IMPORT_VOLY_INTEGRATION = 'CFT_IMPORT_VOLY_INTEGRATION',
  CFT_IMPORT_TIMELINE_LIMIT = 'CFT_IMPORT_TIMELINE_LIMIT',
  CFT_IMPORT_TIMELINE_FEATURE = 'CFT_IMPORT_TIMELINE_FEATURE',
  CFT_IMPORT_FORMULA_ERROR = 'CFT_IMPORT_FORMULA_ERROR',
  CFT_IMPORT_FORMULA_NESTING = 'CFT_IMPORT_FORMULA_NESTING',
}
